import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { ReactionSchema } from '../common';

const c = initContract();
const pathPrefix = '/reference-reactions';

export const referenceReactionContract = c.router(
  {
    fetchReferenceReactions: {
      method: 'POST',
      path: '',
      headers: z.object({
        authorization: z.string(),
      }),
      body: ReactionSchema,
      responses: {
        200: z.string(),
      },
    },
    fetchReferenceReactionsStats: {
      method: 'POST',
      path: '/stats',
      body: ReactionSchema,
      responses: {
        200: z.object({
          count: z.number(),
          hasExactMatch: z.boolean(),
        }),
      },
    },
  },
  { pathPrefix, validateResponseOnClient: true }
);
